import { render } from "./UiTimelinePage.vue?vue&type=template&id=15e1249e&ts=true"
import script from "./UiTimelinePage.vue?vue&type=script&lang=ts"
export * from "./UiTimelinePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__